import { render, staticRenderFns } from "./eventRow.vue?vue&type=template&id=6f04dbd8&scoped=true&"
import script from "./eventRow.vue?vue&type=script&lang=js&"
export * from "./eventRow.vue?vue&type=script&lang=js&"
import style0 from "./eventRow.vue?vue&type=style&index=0&id=6f04dbd8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f04dbd8",
  null
  
)

/* custom blocks */
import block0 from "./eventRow.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VRow})
